document.addEventListener('DOMContentLoaded', function() {
  const cardContainers = document.querySelectorAll('.card-wrapper');
    // Map variant IDs to URLs
    const urlMappings = {
      "42756740677784": "https://www.dermalogica.com/pages/book-a-service?code=CSD30",
      "42756740710552": "https://www.dermalogica.com/pages/book-a-service?code=CSD50",
      "42756748148888": "https://www.dermalogica.com/pages/book-a-service?code=CSBD30",
      "42756748181656": "https://www.dermalogica.com/pages/book-a-service?code=CSBD50"
      // Add more mappings as needed
    };
    cardContainers.forEach(container => {
      const variantInputs = container.querySelectorAll('.variant-choice');
      const bookNowButton = container.querySelectorAll('.book-now-link');
      const cardLinks = container.querySelectorAll('.card > a , .card__heading > a');


      variantInputs.forEach(input => {
        input.addEventListener('click', changeContentCard);
      });

      function changeContentCard() {
        const cardProductMainImg = container.querySelector('.productitem--image-primary');
        const cardProductSecondaryImg = container.querySelector('.productitem--image-secondary');


        const selectedVariantId = this.getAttribute('data-variant-id');
        const selectedVariantURL = this.getAttribute('data-variant-url');
        const selectedVariantBNUrl = urlMappings[selectedVariantId];
        const selectedVariantMainImageSrc = this.getAttribute('data-variant-image-main');

        if (cardProductMainImg) {
          cardProductMainImg.src = selectedVariantMainImageSrc;
          cardProductMainImg.srcset = selectedVariantMainImageSrc;
        }
        if (cardProductSecondaryImg) {
          cardProductSecondaryImg.src = selectedVariantMainImageSrc;
          cardProductSecondaryImg.srcset = selectedVariantMainImageSrc;
        }

        if (cardLinks && selectedVariantURL) {
          cardLinks.forEach(headingCard => {
            headingCard.href = selectedVariantURL;
          });
        }

        if (selectedVariantBNUrl) {
          bookNowButton.forEach(button => {
            button.setAttribute('href', selectedVariantBNUrl);
          });
        } 
      }

      const custom = container.querySelector('.custom-select')
      if(custom){
        const optionList = custom.querySelectorAll('.option');
        optionList.forEach(option => {
          option.addEventListener('click', changeContentCard);
        });
      }
    });

});